import { render, staticRenderFns } from "./ProjectAssetManager.vue?vue&type=template&id=8fa836fc"
import script from "./ProjectAssetManager.vue?vue&type=script&lang=js"
export * from "./ProjectAssetManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports